import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { useNavigate } from 'react-router-dom';
import commonActions from "../../../Actions/commonActions";
import customerActions from "../../../Actions/customerActions";
import CourseList from "./CourseList";

function Courses({ customerActions, commonActions, educations, customer, educationFilters  }) {
    const navigate = useNavigate();
    useEffect(() => {
        customerActions.getEducations()
    }, [])

    const fullWarning = (text, header) => {
        commonActions.showWarning(text, header)
    }
    return <>
        <CourseList educations={educations}
                           redirect={navigate}
                           warning={fullWarning}
                           filters={educationFilters} />
        </>
}

function mapStateToProps(state) {
    return {
        educations: state.CustomerReducer.educations,
        educationFilters: state.CustomerReducer.educationFilters,
        customer: state.CustomerReducer.customer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Courses);